import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';
import { gql, useQuery } from '@apollo/client';

const getQueryName = entity => {
  if (entity === 'article') return 'getPublishedArticle';
  if (entity === 'broker') return 'getPublishedBroker';
  if (entity === 'exhibitor') return 'getPublishedExhibitor';
  if (entity === 'page') return 'getPublishedPage';
  if (entity === 'podcast') return 'getPublishedPodcast';
  if (entity === 'profile') return 'getPublishedProfile';
  if (entity === 'yacht_for_charter') return 'getPublishedYachtForCharter';
  if (entity === 'yacht_for_sale') return 'getPublishedYachtForSale';
  if (entity === 'yacht_page') return 'getPublishedYachtPage';

  return 'getPublishedArticle';
};

const getEntityId = (
  entity,
  {
    articleId,
    brokerId,
    exhibitorId,
    pageId,
    podcastId,
    profileId,
    yachtPageId,
    yachtForCharterId,
    yachtForSaleId
  }
) => {
  if (entity === 'article') return articleId;
  if (entity === 'broker') return brokerId;
  if (entity === 'exhibitor') return exhibitorId;
  if (entity === 'page') return pageId;
  if (entity === 'podcast') return podcastId;
  if (entity === 'profile') return profileId;
  if (entity === 'yacht_for_charter') return yachtPageId;
  if (entity === 'yacht_for_sale') return yachtForCharterId;
  if (entity === 'yacht_page') return yachtForSaleId;

  return null;
};

const OnwardJourney = ({
  entity,
  prefix,
  title,
  articleId,
  brokerId,
  exhibitorId,
  pageId,
  podcastId,
  profileId,
  yachtPageId,
  yachtForCharterId,
  yachtForSaleId
}) => {
  const entityId = getEntityId(entity, {
    articleId,
    brokerId,
    exhibitorId,
    pageId,
    podcastId,
    profileId,
    yachtPageId,
    yachtForCharterId,
    yachtForSaleId
  });
  if (!entityId) return null;

  const { data, error, loading } = useQuery(
    gql`
    query getEntityData($id: String!){
      entityData: ${getQueryName(entity)}(id: $id){
        name,
        url,
        id,
        __typename
      }
    }
  `,
    {
      variables: { id: entityId }
    }
  );

  if (loading) return 'loading...';
  if (error) return error.message;
  if (!data || !data.entityData) return null;

  return (
    <Link href={data.entityData.url} className="onward-journey" data-gtm-id="onward-journey">
      <span className="onward-journey__prefix">{prefix || 'Read More'}</span>

      <span className="onward-journey__separator">/</span>

      <span className="onward-journey__title">{title || data.entityData.name}</span>
    </Link>
  );
};

OnwardJourney.propTypes = {
  entity: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  title: PropTypes.string,
  articleId: PropTypes.string,
  brokerId: PropTypes.string,
  exhibitorId: PropTypes.string,
  pageId: PropTypes.string,
  podcastId: PropTypes.string,
  profileId: PropTypes.string,
  yachtPageId: PropTypes.string,
  yachtForCharterId: PropTypes.string,
  yachtForSaleId: PropTypes.string
};

export default OnwardJourney;
